const Customerinfo = ({customer, footData, quantity}) => {
    console.log('quan',quantity)
    return (
        <div className="sm-text_ customer-info">
            <div className="row mb-2">
                <label className="col-5 fw-bold">Name</label>
                <div className="col-7">
                    <span>:&nbsp;</span> 
                    <span className="text-break">{customer.customer_name}</span>
                </div>
            </div>
            <div className="row mb-2">
                <label className="col-5 fw-bold">Mobile No.</label>
                <div className="col-7">
                    <span>:&nbsp;</span> 
                    <span className="text-break">{customer.phone}</span>
                </div>
            </div>
            {customer.email &&
            <div className="row mb-2">
                <label className="col-5 fw-bold">Email</label>
                <div className="col-7">
                    <span>:&nbsp;</span> 
                    <span className="text-break">{customer.email}</span>
                </div>
            </div>  
            }
            {customer.address &&
            <div className="row mb-2">
                <label className="col-5 fw-bold">Address</label>
                <div className="col-7">
                    <span>:&nbsp;</span> 
                    <span className="text-break">{customer.address}</span>
                </div>
            </div>
            }
            {customer.customer_pan &&
            <div className="row mb-2">
                <label className="col-5 fw-bold">Customer PAN</label>
                <div className="col-7">
                    <span>:&nbsp;</span> 
                    <span className="text-break">{customer.customer_pan}</span>
                </div>
            </div>
            }
            {quantity && 
            <div className="row mb-3">
                <label className="col-5 fw-bold">Total Tickets</label>
                <div className="col-7">
                    : {quantity}
                </div>
            </div>
            }
            <div className="row">
                <label className="col-5"><h6><b>Total</b></h6></label>
                <div className="col-7">
                    <h6>: NPR {footData.total}</h6>
                </div>
            </div>
        </div>
    )
}

export default Customerinfo